import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=373ce33e&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373ce33e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('373ce33e')) {
      api.createRecord('373ce33e', component.options)
    } else {
      api.reload('373ce33e', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=373ce33e&scoped=true&", function () {
      api.rerender('373ce33e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2IdCpOzW0sADv/JS/comp/SearchFilterTokens.vue"
export default component.exports